<template>
  <div class="row mx-3 mb-4">
    <div class="col-12" v-if="!modals.startPointsForThisAreaNotLoaded">
      <div class="row">
        <div
          class="col-12 pr-0"
          :class="isLarge ? 'div_header' : 'div_header_mobile'"
        >
          <i
            class="bi bi-arrow-left ml-3 goBackArrow pt-3"
            v-on:click="goBack(false)"
          ></i>
          <h4>
            <b>Creazione itinerario</b>
          </h4>
        </div>
      </div>
      <div class="row" :style="isLarge ? '' : 'height: 900px;'">
        <div
          class="col-lg-4 col-12 px-3 text-justify"
          :class="isLarge ? 'border-right' : 'mb-4'"
        >

          <!-- lunchPointSelected: {{ lunchPointSelected }} -->
          <ChooseStartPoint
            :startPointSelectedProp="lunchPointSelected"
            :startPointsForEachArea="startPointsForEachArea"
            :currentStep="currentStep"
            :startPointsForThisAreaNotLoaded="
              modals.startPointsForThisAreaNotLoaded
            "
            :amenities="amenities"
            :startPoint="false"
            v-on:checkStartPoint="checkStartPoint"
            v-on:showStartPointOnMap="showStartPointOnMap"
            v-on:resetMarker="resetMarker"
          ></ChooseStartPoint>
        </div>
        <div class="col-lg-8 col-12">
          <l-map
            :zoom="zoom"
            :center="center"
            style="height: 500px"
            class="rounded"
            ref="mappaSceltaPunti"
            @update:center="updateCenter"
          >
            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>

            <l-marker
              v-if="firstPointMarkerLatLng"
              :lat-lng="firstPointMarkerLatLng.getLatLng()"
              :key="'firstActivityPoint'"
            >
              <l-popup
                :options="anchorOptions"
                style="max-width: 250p; min-width: 130px"
              >
                Punto da cui scegliere il pranzo
              </l-popup>
            </l-marker>
            <v-marker-cluster
              ref="cluster"
              :averageCenter="true"
              :ignoreHidden="true"
              :options="clusterOptionsRestaurant"
            >
              <l-marker
                v-for="(restaurant, index) in restaurantsMarkers"
                :lat-lng="restaurant.marker.getLatLng()"
                :key="'restaurant' + index"
              >
                <l-popup
                  :options="anchorOptions"
                  style="max-width: 250p; min-width: 130px"
                >
                  {{ restaurant.POItitle }}
                </l-popup>
                <l-icon ref="icon" :icon-anchor="dynamicAnchor">
                  <img
                    class="marker-icon"
                    :src="require('../icons/restaurant.svg')"
                    v-if="!restaurant.poiSelected"
                  />
                  <img
                    class="marker-icon-start"
                    :src="require('../icons/selected/lunchHere.svg')"
                    v-else
                  />
                </l-icon>
              </l-marker>
            </v-marker-cluster>

            <v-marker-cluster
              ref="clusterBar"
              :averageCenter="true"
              :ignoreHidden="true"
              :options="clusterOptionsRestaurant"
            >
              <l-marker
                v-for="(pub, index) in pubsMarkers"
                :lat-lng="pub.marker.getLatLng()"
                :key="'pub' + index"
              >
                <l-popup
                  :options="anchorOptions"
                  style="max-width: 250p; min-width: 130px"
                >
                  {{ pub.POItitle }}
                </l-popup>
                <l-icon ref="icon" :icon-anchor="dynamicAnchor">
                  <img
                    class="marker-icon"
                    :src="require('../icons/pub.svg')"
                    v-if="!pub.poiSelected"
                  />
                  <img
                    class="marker-icon-start"
                    :src="require('../icons/selected/lunchHere.svg')"
                    v-else
                  />
                </l-icon>
              </l-marker>
            </v-marker-cluster>

            <v-marker-cluster
              ref="clusterHospital"
              :averageCenter="true"
              :ignoreHidden="true"
              :options="clusterOptionsRestaurant"
            >
              <l-marker
                v-for="(fastfood, index) in fastfoodMarkers"
                :lat-lng="fastfood.marker.getLatLng()"
                :key="'fastfood' + index"
              >
                <l-popup
                  :options="anchorOptions"
                  style="max-width: 250p; min-width: 130px"
                >
                  {{ fastfood.POItitle }}
                </l-popup>
                <l-icon ref="icon" :icon-anchor="dynamicAnchor">
                  <img
                    class="marker-icon"
                    :src="require('../icons/fast_food.svg')"
                    v-if="!fastfood.poiSelected"
                  />
                  <img
                    class="marker-icon-start"
                    :src="require('../icons/selected/lunchHere.svg')"
                    v-else
                  />
                </l-icon>
              </l-marker>
            </v-marker-cluster>

            <l-marker
              v-for="(picnicArea, index) in picnicsMarkers"
              :lat-lng="picnicArea.marker.getLatLng()"
              :key="'picnicArea' + index"
            >
              <l-popup
                :options="anchorOptions"
                style="max-width: 250p; min-width: 130px"
              >
                {{ picnicArea.POItitle }}
              </l-popup>
              <l-icon ref="icon" :icon-anchor="dynamicAnchor">
                <img
                  class="marker-icon"
                  :src="require('../icons/taxi.svg')"
                  v-if="!picnicArea.poiSelected"
                />
                <img
                  class="marker-icon-start"
                  :src="require('../icons/selected/lunchHere.svg')"
                  v-else
                />
              </l-icon>
            </l-marker>

            <l-marker
              v-for="(bar, index) in barsMarkers"
              :lat-lng="bar.marker.getLatLng()"
              :key="'bar' + index"
            >
              <l-popup
                :options="anchorOptions"
                style="max-width: 250p; min-width: 130px"
              >
                {{ bar.POItitle }}
              </l-popup>
              <l-icon ref="icon" :icon-anchor="dynamicAnchor">
                <img
                  class="marker-icon"
                  :src="require('../icons/bar.svg')"
                  v-if="!bar.poiSelected"
                />
                <img
                  class="marker-icon-start"
                  :src="require('../icons/selected/lunchHere.svg')"
                  v-else
                />
              </l-icon>
            </l-marker>

            <l-marker
              v-for="(picnicSite, index) in picnicSiteMarkers"
              :lat-lng="picnicSite.marker.getLatLng()"
              :key="'picnicSite' + index"
            >
              <l-popup
                :options="anchorOptions"
                style="max-width: 250p; min-width: 130px"
              >
                {{ picnicSite.POItitle }}
              </l-popup>
              <l-icon ref="icon" :icon-anchor="dynamicAnchor">
                <img
                  class="marker-icon"
                  :src="require('../icons/picnicSite.svg')"
                  v-if="!picnicSite.poiSelected"
                />
                <img
                  class="marker-icon-start"
                  :src="require('../icons/selected/lunchHere.svg')"
                  v-else
                />
              </l-icon>
            </l-marker>
          </l-map>
        </div>
      </div>
    </div>

    <!--modal caricamento-->
    <modal
      :show.sync="modals.startPointsForThisAreaNotLoaded"
      headerClasses="justify-content-center"
      @close="modals.startPointsForThisAreaNotLoaded = true"
    >
      <h4 slot="header" class="title title-up text-center">
        Caricamento in corso
      </h4>
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12 text-center">
              <svg class="circular">
                <circle
                  class="path"
                  cx="50"
                  cy="50"
                  r="20"
                  fill="none"
                  stroke-width="5"
                  stroke-miterlimit="10"
                ></circle>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <template slot="close-button">
        <span></span>
      </template>
    </modal>

    <!--modal punto non selezionato-->

    <modal
      :show.sync="modals.lunchPointNotSelected"
      headerClasses="justify-content-center"
      @close="modals.lunchPointNotSelected = false"
    >
      <h4 slot="header" class="title title-up text-center">Attenzione!</h4>
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12 text-center">
              <h6 class="itineraryCode">
                Devi selezionare il posto in cui pranzare per proseguire.
              </h6>
            </div>
          </div>
        </div>
      </div>

      <template slot="footer">
        <Button
          size="small"
          type="danger"
          v-on:click="modals.lunchPointNotSelected = false"
          class="mx-1"
          >Chiudi
        </Button>
      </template>
    </modal>

    <ContinueFloatingButton
      v-on:continue="goToCreatePath()"
    ></ContinueFloatingButton>
  </div>
</template>

<script>
const Common = require("@/Common.vue").default;

import Vue from "vue";
import { Icon, divIcon } from "leaflet";

import $ from "jquery";
import { Button } from "element-ui";
import {
  Checkbox,
  Radio,
  Collapse,
  CollapseItem,
  Modal,
  FormGroupInput,
} from "../components";
import "v-alert-resource/dist/v-alert-resource.css";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import store from "../store";
import Vuex from "vuex";
import router from "../router";
import { config } from "../utils/config";
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";

import ClusterIcon from "./cluster-icon";
import { ref, nextTick } from "vue";

const EnhancedClusterIcon = Vue.extend(ClusterIcon);

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

import {
  LMap,
  LMarker,
  LPopup,
  LIcon,
  LTileLayer,
  LControl,
} from "vue2-leaflet";
import ContinueFloatingButton from "../components/customComponents/ContinueFloatingButton.vue";

import ChooseStartPoint from "../components/customComponents/ChooseStartPoint.vue";

export default {
  name: "sceltapranzo",
  bodyClass: "percorsi-page",

  components: {
    [Radio.name]: Radio,
    [Checkbox.name]: Checkbox,
    LMap,
    LMarker,
    LTileLayer,
    LPopup,
    LIcon,
    Button,
    Modal,
    ContinueFloatingButton,
    ChooseStartPoint,
    "v-marker-cluster": Vue2LeafletMarkerCluster,
  },

  data() {
    return {
      clusterOptionsRestaurant: {
        spiderfyDistanceMultiplier: 4,
        iconCreateFunction: (cluster) => {
          let clusterUsers = cluster
            .getAllChildMarkers()
            .map((marker) => marker.id);
          let clusterIconEl = new EnhancedClusterIcon({
            propsData: { clusterUsers, type: "bar" },
          }).$mount().$el;
          return divIcon({
            html: clusterIconEl.outerHTML,
            className: "cluster",
            iconSize: null,
          });
        },
      },

      windowWidth: 0,
      config: null,

      zoom: 5,
      center: [45.47724690648075, 7.888264286334166],
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      markers: [],
      anchorOptions: { offset: L.point(-6.5, -37) },

      lunchTypes: ["Ristorante", "Pranzo al sacco"],

      coordsOfSelectedStartPoint: null,

      firstPointMarkerLatLng: null,

      amenities: [
        { tag: "bbq", label: "Barbeque" },
        { tag: "restaurant", label: "Ristoranti" },
        { tag: "pub", label: "Pub" },
        { tag: "fast_food", label: "Fast Food" },
        { tag: "bar", label: "Bar" },
        { tag: "cafe", label: "Cafè" },
        { tag: "picnic_site", label: "Aree Picnic" },
      ],

      currentStep: 0,

      startPointsForEachArea: [],
      selectedStartPointForEachArea: [],
      modals: {
        startPointsForThisAreaNotLoaded: true,
        lunchPointNotSelected: false,
      },

      lunchPointSelected: "",
    };
  },

  computed: {
    ...Vuex.mapGetters([]),

    dynamicAnchor() {
      return [20, 64 * 0.65];
    },

    selectedLunchPoint() {
      return this.$store.state.selectedLunchPoint;
    },

    isLarge() {
      return this.windowWidth >= 768;
    },

    restaurantsMarkers() {
      return this.startPointsForEachArea.length > 0
        ? this.startPointsForEachArea[this.currentStep].filter(
            (point) => point.type === "restaurant"
          )
        : [];
    },
    pubsMarkers() {
      return this.startPointsForEachArea.length > 0
        ? this.startPointsForEachArea[this.currentStep].filter(
            (point) => point.type === "pub"
          )
        : [];
    },
    fastfoodMarkers() {
      return this.startPointsForEachArea.length > 0
        ? this.startPointsForEachArea[this.currentStep].filter(
            (point) => point.type === "fast_food"
          )
        : [];
    },
    bbqsMarkers() {
      return this.startPointsForEachArea.length > 0
        ? this.startPointsForEachArea[this.currentStep].filter(
            (point) => point.type === "bbq"
          )
        : [];
    },
    picnicsMarkers() {
      return this.startPointsForEachArea.length > 0
        ? this.startPointsForEachArea[this.currentStep].filter(
            (point) => point.type === "pic_nic"
          )
        : [];
    },
    librariesMarkers() {
      return this.startPointsForEachArea.length > 0
        ? this.startPointsForEachArea[this.currentStep].filter(
            (point) => point.type === "library"
          )
        : [];
    },
    barsMarkers() {
      return this.startPointsForEachArea.length > 0
        ? this.startPointsForEachArea[this.currentStep].filter(
            (point) => point.type === "bar"
          )
        : [];
    },
    picnicSiteMarkers() {
      return this.startPointsForEachArea.length > 0
        ? this.startPointsForEachArea[this.currentStep].filter(
            (point) => point.type === "picnic_site"
          )
        : [];
    },
  },

  async created() {
    var self = this;

    this.windowWidth = $(window).width();

    $(window).resize(() => {
      this.windowWidth = $(window).width();
    });

  },

  beforeMount() {
    //chiedo gli esperimenti perchè magari non sono mai andato nella pagina dedicata a loro prima d'ora, ma mi servono qua
    Common.getElemsByClass(this, config.omekaIDs.omekaIDattivita, (res) => {
      store.state.esperimenti = res.body;
      store.commit("setActivitiesInPOI");
    });
  },

  mounted() {
    var self = this;

    var itinerarioVROOM = JSON.parse(sessionStorage.getItem("itinerarioVROOM")); //contiene i vari sottoitinerari

    this.startPointsForEachArea = Array(itinerarioVROOM.length).fill([]); // array in cui in ogni posizione c'è il punto scelto di partenza

    this.currentStep = 0;
    this.initFunction(itinerarioVROOM);
  },

  methods: {
    initFunction(itinerarioVROOM) {
      if (this.startPointsForEachArea[this.currentStep].length === 0) {
        if (this.selectedLunchPoint !== null) {
          this.lunchPointSelected = this.selectedLunchPoint[0].POItitle;
        } else {
          this.lunchPointSelected = "";
        }

        var indexSottoitinerarioForLunch =
          store.getters.getPositionIndexForLunch.indexSottoitinerario;
        var indexPoi = store.getters.getPositionIndexForLunch.indexPoi;

        console.log("PUNTO PRANZO");
        console.log(
          itinerarioVROOM[indexSottoitinerarioForLunch].poi[indexPoi]
        );

        console.log(itinerarioVROOM[indexSottoitinerarioForLunch]);

        var lat = itinerarioVROOM[indexSottoitinerarioForLunch].poi[indexPoi]
          .location[0] < 40 ? itinerarioVROOM[indexSottoitinerarioForLunch].poi[indexPoi]
          .location[1] : itinerarioVROOM[indexSottoitinerarioForLunch].poi[indexPoi].location[0];

        var lng = itinerarioVROOM[indexSottoitinerarioForLunch].poi[indexPoi]
          .location[0] < 40 ? itinerarioVROOM[indexSottoitinerarioForLunch].poi[indexPoi]
          .location[0] : itinerarioVROOM[indexSottoitinerarioForLunch].poi[indexPoi].location[1];


        this.firstPointMarkerLatLng = L.marker([
          lat,
          lng,
        ]);

        this.zoom = 18;

        this.center = L.latLng(
          lat,
          lng
        );

        this.$store.commit("removeOtherObjects");
        this.config = config;

        var self = this;

        // var query = "[out:json][timeout:25];(";
        var query = "[out:json];(";

        //var queryNew = "[out:json][timeout:25];(node[amenity=parking](around: 1000, " + itinerarioVROOM[0].poi[1].location[1] + "," + itinerarioVROOM[0].poi[1].location[0] + ");way[amenity=parking](around: 1000, " + itinerarioVROOM[0].poi[1].location[1] + "," + itinerarioVROOM[0].poi[1].location[0] + ");relation[amenity=parking](around: 1000, " + itinerarioVROOM[0].poi[1].location[1] + "," + itinerarioVROOM[0].poi[1].location[0] + "););out center;";

        Array.prototype.forEach.call(this.amenities, (amenity, index) => {
          if (amenity.tag !== "station") {
            var string =
              "node[amenity=" +
              amenity.tag +
              "](around: 1000, " +
              lat +
              "," +
              lng +
              ");way[amenity=" +
              amenity.tag +
              "](around: 1000, " +
              lat +
              "," +
              lng +
              ");relation[amenity=" +
              amenity.tag +
              "](around: 1000, " +
              lat +
              "," +
              lng +
              ");";
            query += string;
          }
        });

        var string =
          "node[tourism=picnic_site](around: 1000, " +
          lat +
          "," +
          lng +
          ");way[tourism=picnic_site](around: 1000, " +
          lat +
          "," +
          lng +
          ");relation[tourism=picnic_site](around: 1000, " +
          lat +
          "," +
          lng +
          ");";
        query += string;

        query += ");out center;";

        console.log(query);

        (async () => {
          const api = await fetch(
            "https://www.overpass-api.de/api/interpreter?",
            {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: query,
            } //node(dal centro in basso, dal centro a sinistra, dal centro in alto, dal centro a destra)
          ).catch((error) => {
            // Your error is here!
          });
          const answer = await api.json();

          console.log("ANSWER");
          console.log(answer);

          var startPoints = [];

          Array.prototype.forEach.call(answer.elements, (elem, index) => {
            if (elem.tags.amenity === "restaurant") {
              this.addNodeElemToCorrectArray(
                elem,
                index,
                "Ristorante ",
                "restaurant",
                startPoints
              );
            } else if (elem.tags.amenity === "pub") {
              this.addNodeElemToCorrectArray(
                elem,
                index,
                "Pub ",
                "pub",
                startPoints
              );
            } else if (elem.tags.amenity === "fast_food") {
              this.addNodeElemToCorrectArray(
                elem,
                index,
                "Fast Food ",
                "fast_food",
                startPoints
              );
            } else if (elem.tags.amenity === "bbq") {
              this.addNodeElemToCorrectArray(
                elem,
                index,
                "Barbeque ",
                "bbq",
                startPoints
              );
            } else if (elem.tags.tourism === "picnic_site") {
              this.addNodeElemToCorrectArray(
                elem,
                index,
                "Area Picnic ",
                "picnic_site",
                startPoints
              );
            } else if (
              elem.tags.amenity === "bar" ||
              elem.tags.amenity === "cafe"
            ) {
              this.addNodeElemToCorrectArray(
                elem,
                index,
                "Bar ",
                "bar",
                startPoints
              );
            }
          });

          var currentStep = this.currentStep;
          Vue.set(this.startPointsForEachArea, currentStep, startPoints);

          self.modals.startPointsForThisAreaNotLoaded = false;
        })().catch((error) => {
          // Your error is here!
        });
      } else {
        this.modals.startPointsForThisAreaNotLoaded = false;
      }

      if (store.getters.timeSlotRadio === null) {
        var timeSlotRadio = this.config.omekaIDs.timeSlots[0];
        this.$store.commit("setTimeSlotRadio", { timeSlotRadio });
      }

    },
    updateCenter(center) {
      // this.center = center;
    },
    resetMarker(poiName) {
      var result = this.startPointsForEachArea[this.currentStep].findIndex(
        (startPoint, index) => {
          return startPoint.POItitle === poiName;
        }
      );

      Vue.set(
        this.startPointsForEachArea[this.currentStep][result],
        "poiSelected",
        false
      );
    },
    showStartPointOnMap() {
      // this.$refs.mappaSceltaPunti.setCenter(
      //   new L.latLng(
      //     this.selectedLunchPoint.marker["_latlng"].lat + 0.000001,
      //     this.selectedLunchPoint.marker["_latlng"].lng +  0.000001
      //   )
      // );

      this.zoom = 18;
      // this.center = L.latLng(
      //   store.getters.getSelectedLunchPoint[0].marker["_latlng"].lat,
      //   store.getters.getSelectedLunchPoint[0].marker["_latlng"].lng
      // );

      // this.center = [
      //   this.selectedLunchPoint.marker["_latlng"].lat,
      //   this.selectedLunchPoint.marker["_latlng"].lng,
      // ];
    },
    addNodeElemToCorrectArray(elem, index, stringName, stringType, array) {
      var pointsLatLng = [];

      if (elem.type === "node") {
        pointsLatLng = array.filter(function (point) {
          return (
            point.marker.getLatLng().lat.toFixed(3) === elem.lat.toFixed(3) &&
            point.marker.getLatLng().lng.toFixed(3) === elem.lon.toFixed(3)
          );
        });
      } else {
        pointsLatLng = array.filter(function (point) {
          return (
            point.marker.getLatLng().lat.toFixed(3) ===
              elem.center.lat.toFixed(3) &&
            point.marker.getLatLng().lng.toFixed(3) ===
              elem.center.lon.toFixed(3)
          );
        });
      }

      if (elem.tags.name) {
        var points = array.filter(function (point) {
          return point.POItitle === stringName + elem.tags.name;
        });

        if (points.length === 0 && pointsLatLng.length === 0) {
          array.push({
            marker:
              elem.type === "node"
                ? L.marker([elem.lat, elem.lon])
                : L.marker([elem.center.lat, elem.center.lon]),
            color: "#1585bd",
            strokeColor: "#1b4f88",
            circleColor: "#ffffff",
            POItitle: elem.tags.name
              ? stringName + elem.tags.name
              : stringName + index,
            poiSelected: false,
            image: undefined,
            type: stringType,
          });
        }
      } else {
        if (pointsLatLng.length === 0) {
          array.push({
            marker:
              elem.type === "node"
                ? L.marker([elem.lat, elem.lon])
                : L.marker([elem.center.lat, elem.center.lon]),
            color: "#1585bd",
            strokeColor: "#1b4f88",
            circleColor: "#ffffff",
            POItitle: elem.tags.name
              ? stringName + elem.tags.name
              : stringName + index,
            poiSelected: false,
            image: undefined,
            type: stringType,
          });
        }
      }
    },
    addWayElemToCorrectArray(elem, index, stringName, stringType, array) {
      var pointsLatLng = array.filter(function (point) {
        return (
          point.marker.getLatLng().lat.toFixed(3) ===
            elem.center.lat.toFixed(3) &&
          point.marker.getLatLng().lng.toFixed(3) === elem.center.lon.toFixed(3)
        );
      });

      if (elem.tags.name) {
        var points = array.filter(function (point) {
          return point.POItitle === stringName + elem.tags.name;
        });

        if (points.length === 0 && pointsLatLng.length === 0) {
          array.push({
            marker: L.marker([elem.center.lat, elem.center.lon]),
            color: "#1585bd",
            strokeColor: "#1b4f88",
            circleColor: "#ffffff",
            POItitle: elem.tags.name
              ? stringName + elem.tags.name
              : stringName + index,
            poiSelected: false,
            image: undefined,
            type: stringType,
          });
        }
      } else {
        if (pointsLatLng.length === 0) {
          array.push({
            marker: L.marker([elem.center.lat, elem.center.lon]),
            color: "#1585bd",
            strokeColor: "#1b4f88",
            circleColor: "#ffffff",
            POItitle: elem.tags.name
              ? stringName + elem.tags.name
              : stringName + index,
            poiSelected: false,
            image: undefined,
            type: stringType,
          });
        }
      }
    },
    goBack(goToStartPageCreateItinerary) {
      if (this.currentStep > 0 && !goToStartPageCreateItinerary) {
        var currentStep = this.currentStep - 1;
        this.$store.commit("setCurrentStepChooseStartPoint", {
          currentStep: currentStep,
        });

        this.currentStep--;
        this.lunchPointSelected = "";

        this.modals.startPointsForThisAreaNotLoaded = true;

        var itinerarioVROOM = JSON.parse(
          sessionStorage.getItem("itinerarioVROOM")
        ); //

        this.center = L.latLng(
          itinerarioVROOM[this.currentStep].poi[1].location[1],
          itinerarioVROOM[this.currentStep].poi[1].location[0]
        );

        this.firstPointMarkerLatLng = L.marker([
          itinerarioVROOM[this.currentStep].poi[1].location[1],
          itinerarioVROOM[this.currentStep].poi[1].location[0],
        ]);

        this.initFunction(itinerarioVROOM);
      } else {
        var itinerarioVROOM = JSON.parse(
          sessionStorage.getItem("itinerarioVROOM")
        ); //

        this.$store.commit("setCurrentStepChooseStartPoint", {
          currentStep: 0,
        });

        var arr = Array(itinerarioVROOM.length).fill(null); // array in cui in ogni posizione c'è il punto scelto di partenza

        this.$store.commit("setSelectedStartPoint", { value: arr });

        router.go(-1);
      }
    },

    goToCreatePath() {
      if (this.lunchPointSelected !== "") {
        var itineraryAlreadyExist = this.itineraryAlreadyExist;
        var itineraryCode = this.itineraryCode;

        if (
          this.selectedLunchPoint !== null &&
          this.selectedLunchPoint !== undefined
        ) {
          var itineraryAlreadyExist = this.$route.params.itineraryAlreadyExist;
          var itineraryCode = this.$route.params.itineraryCode;

          router.push({
            name: "sceltaopzioni",
            params: { step: 0, itineraryAlreadyExist, itineraryCode },
            query: { type: 0 },
          });
        } else {
          this.modals.lunchPointNotSelected = true;
        }
      } else {
        this.modals.lunchPointNotSelected = true;
      }
    },



    checkStartPoint(index, pointParam, isMarker, POIname) {
      if (POIname) {
        this.lunchPointSelected = POIname;
      } else {
        this.lunchPointSelected = "";
      }

      //TODO: QUANDO SI PULISCE IL PUNTO, CAMBIARE MARKER SELEZIONATO

      if (POIname !== undefined && POIname !== "") {
        var point = this.startPointsForEachArea[this.currentStep].filter(
          (p) => {
            return p.POItitle === POIname;
          }
        );

        var oldStartPoint = this.startPointsForEachArea[
          this.currentStep
        ].filter((p) => {
          return p.poiSelected === true;
        });

        if (oldStartPoint.length > 0) {
          oldStartPoint[0].poiSelected = false; // deseleziono quello di prima
        }

        if (!isMarker) {
          point[0].poiSelected = true;

          var currentStep = this.currentStep;

          this.$store.commit("setSelectedLunchPoint", {
            selectedLunchPoint: point,
          });
        } else {
          point[0].poiSelected = !point[0].poiSelected;

          if (point[0].poiSelected) {
            var currentStep = this.currentStep;

            this.$store.commit("setSelectedLunchPoint", {
              selectedLunchPoint: point,
            });

            this.lunchPointSelected = point[0].POItitle;
          } else {
            var point = null;
            var currentStep = this.currentStep;
            this.lunchPointSelected = "";

            this.$store.commit("setSelectedStartPointsArray", {
              point,
              currentStep,
            });
          }
        }

        this.center = L.latLng(
          point[0].marker["_latlng"].lat,
          point[0].marker["_latlng"].lng
        );

        this.coordsOfSelectedStartPoint = [
          point[0].marker["_latlng"].lat,
          point[0].marker["_latlng"].lng,
        ];

        this.showStartPointOnMap();

        this.zoom = 18;
      }
    },
  },
};
</script>

<style>
</style>
